// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import App from './App'
import router from './router'

import 'gooey-ui/dist/gooey-ui.css'
import '../static/style.scss'

Vue.use(VeeValidate);
Vue.config.productionTip = false;

Vue.directive('loading', {
	inserted: function(el, binding) {
		if(binding.value) {
			// console.log(el.getBoundingClientRect());
			let elBox = el.getBoundingClientRect();
			let mask = document.createElement('div');
			mask.classList.add('gw-loading-mask');
			// console.log(el, elBox);
			// console.log(el.scrollWidth, el.offsetWidth, el.offsetLeft);
			mask.setAttribute('style', 'width:' + elBox.width + 'px;height:' + elBox.height + 'px;x:' + elBox.x + ';y:' + elBox.y + ';');
			// console.log(mask.style.cssText);
			// mask.style.height = elBox.height;
			// mask.style.x = elBox.x;
			// mask.style.y = elBox.y;
			el.parentNode.insertBefore(mask, el);
		}
	}
});

export const bus = new Vue();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
